import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=440a7e89&lang=less"
import "./App.vue?vue&type=style&index=1&id=440a7e89&lang=less&scoped=true"
script.__scopeId = "data-v-440a7e89"

export default script